import { useMemo } from 'react';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PlaylistAssignmentsProgressContainer from './PlaylistAssignmentsProgressContainer';
import { getTotalProgressFromItemsProgress } from '../playlistAssignmentsUtils';
import { UserLink } from '../../users';
import { AvatarViewer } from '../../avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentProgress = ({
  assignment: {
    assignee: {
      firstName,
      lastName,
      userId,
      avatarHash
    },
    portalId,
    progress
  }
}) => {
  const displayName = formatName({
    firstName,
    lastName
  });
  const {
    itemsProgress
  } = progress || {
    itemsProgress: []
  };
  const progressPercentage = useMemo(() => getTotalProgressFromItemsProgress(itemsProgress), [itemsProgress]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    gap: 24,
    children: [/*#__PURE__*/_jsx(UserLink, {
      portalId: portalId,
      userId: userId,
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        displayName: displayName,
        size: "md",
        type: "contact"
      })
    }), /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
      children: [/*#__PURE__*/_jsx(UserLink, {
        external: true,
        portalId: portalId,
        userId: userId,
        children: displayName
      }), /*#__PURE__*/_jsx(Progress, {
        "aria-label": I18n.text('learningCenter.playlistAssignments.assignmentProgress', {
          progressPercentage: I18n.formatPercentage(progressPercentage)
        }),
        use: "success",
        value: progressPercentage
      })]
    })]
  });
};
export default PlaylistAssignmentProgress;